module.exports = {"filtersTab0":[{"label":"Inicio de Vigencia","filterKey":"startDate","type":"date","filterCondition":"btw","value":""}]}


//////////////////
// WEBPACK FOOTER
// ./src/containers/agent/data/defaultFilters.json
// module id = 922
// module chunks = 16